// var baseUrl = 'https://gtdc1ap001.eastus.cloudapp.azure.com';
  var baseUrl = 'https://shopify-gateway.tronair.com';

$(document).ready(function () {
  $('#order-lookup-btn').click(function () {
    $('.details-container').remove();
    var orderNumber = $('#order-lookup-input').val();
    var startDate = $('#order-start-date').val();
    var endDate = $('#order-end-date').val();
    var partNumber = $('#part-number').val();
    if(!!orderNumber) {
      searchOrder(orderNumber);
    } else if (!!startDate && !!endDate) {
      getOrders(startDate, endDate, partNumber);
    } else if (!!partNumber) {
      getOrders(null, null, partNumber);
    } else {
      alert('Must enter an order number, part number, or both a start date and an end date');
    }
  });

  if (!!$('#order-lookup-input').val()) $('#order-lookup-btn').trigger('click');
});

function clearFields() {
  $('#order-lookup-input').val('');
  $('#order-start-date').val('');
  $('#order-end-date').val('');
  $('#part-number').val('');
  getOrders();
}

function extractTrackingNumber(trackingURL) {
  if (!trackingURL) return null;

  try {
    const url = new URL(trackingURL);

    // Map possible query params to look up for tracking number
    const paramCandidates = [
      "trackNums",          // UPS
      "tracknumbers",       // FedEx
      "tracking-id",        // DHL
      "trkNum",             // Some others / fallback
    ];

    // Try all known query params
    for (const param of paramCandidates) {
      const val = url.searchParams.get(param);
      if (val) return val;
    }

    return null; // No known tracking number found
  } catch (e) {
    // fallback to regex just in case (bad URL string, etc)
    const match = trackingURL.match(/([A-Z0-9]{9,})/gi);
    if (match && match.length > 0) {
      return match[0];
    }
  }
  return null;
}

function searchOrder(orderNumber) {
  $('.details-container').remove();

  var customerId = $('#customer-id').val();

  $.ajax({
    url: baseUrl + '/shopify/searchorder',
    type: 'GET',
    data: {
      customerId,
      orderNumber
    },
    success: function (response) {
      if(!!response) {
        console.log(response)
        const orderNumber = response.order;
        const orderPurchaseOrderNumber = response.purchaseOrderNumber;
        const orderTotal = parseFloat(response.invoiceTotal).toFixed(2);
        const shippedItems = response.shippedItems || [];

        let shippedName, shippedAddress, shippedCity, shippedState, shippedZip;
        if (shippedItems.length > 0) {
          shippedName = shippedItems[0].shipToName;
          shippedAddress = shippedItems[0].shipToAddress1;
          shippedCity = shippedItems[0].shipToCity;
          shippedState = shippedItems[0].shipToState;
          shippedZip = shippedItems[0].shipToZip;
        } else if (!!response.shipToOverride) {
          shippedName = response.shipToOverride.name;
          shippedAddress = response.shipToOverride.addressLine1;
          shippedCity = response.shipToOverride.city;
          shippedState = response.shipToOverride.state;
          shippedZip = response.shipToOverride.zip;
        }

        var startDate = $('#order-start-date').val() ? $('#order-start-date').val() : null;
        var endDate = $('#order-end-date').val() ? $('#order-end-date').val() : null;
        var partNumber = $('#part-number').val() ? $('#part-number').val() : null;
        
        var orderDetails = `<div class="details-container">`;
        orderDetails += `<a href="javascript:getOrders(${startDate ? "'" + startDate + "'" : null}, ${endDate ? "'" + endDate + "'" : null}, ${partNumber ? "'" + partNumber + "'" : null});">Back to orders</a>`;
        orderDetails += `<h2>Customer Order: ${orderNumber}<br>Purchase Order: ${orderPurchaseOrderNumber}</h2>`;
        orderDetails += `<table role="table" class="order-details">`;
        orderDetails += `<caption class="visually-hidden">Order #${orderNumber}</caption>`;
        orderDetails += `<thead role="rowgroup" style="background-color: #326cb0; color: white; font-weight: 800;"><tr role="row">`;
        orderDetails += `<th id="ColumnInternalItemNumber" scope="col" role="columnheader">Part Number/<br>Description</th>`;
        orderDetails += `<th id="ColumnInternalItemNumber" scope="col" role="columnheader">Serial Number</th>`;
        orderDetails += `<th id="ColumnSequenceNumber" scope="col" role="columnheader">Line Item #</th>`;
        orderDetails += `<th id="ColumnPrice" scope="col" role="columnheader">Unit Price</th>`;
        orderDetails += `<th id="ColumnQuantity" scope="col" role="columnheader">Quantity</th>`;
        orderDetails += `<th id="ColumnSubtotal" scope="col" role="columnheader">Subtotal</th>`;
        orderDetails += `<th id="ColumnShipDate" scope="col" role="columnheader">Status</th>`;
        orderDetails += `</tr></thead>`;
        orderDetails += `<tbody role="rowgroup">`;

        let i = 0;
        if(!!response.lineItems && response.lineItems.length > 0) {
          response.lineItems.forEach(lineItem => {
            const itemInternalItem = lineItem.internalItem;
            const hasShipped = !lineItem.promiseDate;
            let itemDescription, itemSequenceNumber, itemPrice, itemQuantity, itemSubTotal, itemShipDate, shipMethod, trackingURL, trackingNumber;
            if (!hasShipped) {
              itemDescription = lineItem.itemDescription;
              itemSequenceNumber = lineItem.userEnteredSequenceNumber;
              itemPrice = parseFloat(lineItem.sellingPrice).toFixed(2);
              itemQuantity = parseInt(lineItem.orderQuantityInOrderUnitOfMeasure);
              itemSubTotal = parseFloat(lineItem.subTotal).toFixed(2);

              // format the date to MM/DD/YYYY
              const itemPromiseDate = new Date(lineItem.promiseDate);
              itemShipDate = itemPromiseDate.toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
              });
            } else if(!!response.shippedItems && response.shippedItems.length > 0) {
              response.shippedItems.forEach(shippedItem => {
                if (shippedItem.item !== itemInternalItem) return;

                itemDescription = shippedItem.itemDescription;
                itemSequenceNumber = shippedItem.userEnteredSequenceNumber;
                itemPrice = parseFloat(shippedItem.sellingPrice).toFixed(2);
                itemQuantity = parseInt(shippedItem.shippedQuantityInStockingUnitOfMeasure);
                itemSubTotal = parseFloat(shippedItem.netSalesAmountLocalCurrency).toFixed(2);
                shipMethod = shippedItem.carrierId;
                trackingURL = shippedItem.trackingURL;
                trackingNumber = trackingURL ? extractTrackingNumber(trackingURL) : null;

                // format the date to MM/DD/YYYY
                const itemShipmentDate = new Date(shippedItem.shipmentDate);
                itemShipDate = itemShipmentDate.toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit'
                });
              });
            }

            orderDetails += `<tr role="row">`;
            orderDetails += `<td headers="ColumnInternalItemNumber" role="rowheader" scope="row" data-label="Product">${itemInternalItem}`;
            if (itemDescription) orderDetails += `<br>${itemDescription}`;
            orderDetails += `</td>`;
            
            const associatedShipment = findShipment(response, lineItem);
            if (associatedShipment === null)  {
              orderDetails += `<td headers="ColumnInternalItemNumber" role="rowheader" scope="row" data-label="Serial Number">N/A</td>`;
            } else {
              orderDetails += `<td headers="ColumnInternalItemNumber" role="rowheader" scope="row" data-label="Serial Number">${associatedShipment.serialNumbers.join(', ')}</td>`;
            }
  
            orderDetails += `<td headers="ColumnSequenceNumber" role="cell" data-label="Line Item Number">${itemSequenceNumber}</td>`;
            orderDetails += `<td headers="ColumnPrice" role="cell" data-label="Price">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(itemPrice)}</td>`;
            orderDetails += `<td headers="ColumnQuantity" role="cell" data-label="Quantity">${itemQuantity}</td>`;
            orderDetails += `<td headers="ColumnSubtotal" role="cell" data-label="Total">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(itemSubTotal)}</td>`;
            orderDetails += `<td headers="ColumnShipDate" role="cell" data-label="Ship Date">`;
            if (hasShipped) orderDetails += `<span class="shipped">Shipped ${shipMethod ? shipMethod : 'on'}</span>`;
            if (!hasShipped) orderDetails += `<span class="not-shipped">Scheduled on</span>`;
            orderDetails += `<br>${itemShipDate}`;
            if (trackingNumber) {
              orderDetails += `<br><a href="${trackingURL}" target="_blank" rel="noopener noreferrer">${trackingNumber}</a>`;
            } else if (trackingURL) {
              orderDetails += `<br><a href="${trackingURL}" target="_blank" rel="noopener noreferrer">Track Order</a>`;
            }
            orderDetails += `</td>`;
            orderDetails += `</tr>`;
            i++;
          });
        } else if(!!response.shippedItems && response.shippedItems.length > 0) {
          response.shippedItems.forEach(shippedItem => {
            const itemInternalItem = shippedItem.item;
            const itemDescription = shippedItem.itemDescription;
            const itemSequenceNumber = shippedItem.userEnteredSequenceNumber;
            const itemPrice = parseFloat(shippedItem.sellingPrice).toFixed(2);
            const itemQuantity = parseInt(shippedItem.shippedQuantityInStockingUnitOfMeasure);
            const itemSubTotal = parseFloat(shippedItem.netSalesAmountLocalCurrency).toFixed(2);
            const shipMethod = shippedItem.carrierId;
            const trackingURL = shippedItem.trackingURL;
            const trackingNumber = trackingURL ? extractTrackingNumber(trackingURL) : null;

            // format the date to MM/DD/YYYY
            const itemShipmentDate = new Date(shippedItem.shipmentDate);
            const itemShipDate = itemShipmentDate.toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            });

            orderDetails += `<tr role="row">`;
            orderDetails += `<td headers="ColumnInternalItemNumber" role="rowheader" scope="row" data-label="Product">${itemInternalItem}`;
            if (itemDescription) orderDetails += `<br>${itemDescription}`;
            orderDetails += `</td>`;
            
            if (!shippedItem.serialNumbers || shippedItem.serialNumbers.length === 0) {
              orderDetails += `<td headers="ColumnInternalItemNumber" role="rowheader" scope="row" data-label="Serial Number">N/A</td>`;
            } else {
              orderDetails += `<td headers="ColumnInternalItemNumber" role="rowheader" scope="row" data-label="Serial Number">${shippedItem.serialNumbers.join(', ')}</td>`;
            }

            orderDetails += `<td headers="ColumnSequenceNumber" role="cell" data-label="Line Item Number">${itemSequenceNumber}</td>`;
            orderDetails += `<td headers="ColumnPrice" role="cell" data-label="Price">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(itemPrice)}</td>`;
            orderDetails += `<td headers="ColumnQuantity" role="cell" data-label="Quantity">${itemQuantity}</td>`;
            orderDetails += `<td headers="ColumnSubtotal" role="cell" data-label="Total">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(itemSubTotal)}</td>`;
            orderDetails += `<td headers="ColumnShipDate" role="cell" data-label="Ship Date">`;
            orderDetails += `<span class="shipped">Shipped `;
            shipMethod ? orderDetails += `${shipMethod}` : orderDetails += `on`;
            orderDetails += `</span>`;
            orderDetails += `<br>${itemShipDate}`;
            if (trackingNumber) {
              orderDetails += `<br><a href="${trackingURL}" target="_blank" rel="noopener noreferrer">${trackingNumber}</a>`;
            } else if (trackingURL) {
              orderDetails += `<br><a href="${trackingURL}" target="_blank" rel="noopener noreferrer">Track Order</a>`;
            }
            orderDetails += `</td>`;
            orderDetails += `</tr>`;
          });
          i++
        }

        orderDetails += `<tfoot role="rowgroup">`;
        orderDetails += `<tr role="row"><td id="RowSubtotal" role="rowheader" scope="row" colspan="4">Subtotal</td><td headers="RowSubtotal" role="cell" data-label="Subtotal">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderTotal)}</td></tr>`;
        orderDetails += `<tr role="row"><td id="RowTotal" role="rowheader" scope="row" colspan="3">Total</td><td headers="RowTotal" role="cell" colspan="2" data-label="Total">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderTotal)}</td></tr>`;
        orderDetails += `</tfoot>`;

        orderDetails += `</tbody>`;
        orderDetails += `</table>`;

        orderDetails += `<div>`;
        orderDetails += `<h2>Shipping Address</h2>`;
        orderDetails += `<p>${shippedName}</p>`;
        orderDetails += `<p>${shippedAddress}</p>`;
        orderDetails += `<p>${shippedCity} ${shippedState}, ${shippedZip}</p>`;
        orderDetails += `</div>`;

        orderDetails += `</div>`;
        console.log(orderDetails)
        $('.order-lookup').append(orderDetails);
      } else {
        var orderDetails = `<div class="details-container" style="font-size: 20px;">Unfortunately, we couldn't retrieve the requested data. For further support, please retry your request or contact sales@tronair.com.</div>`;
        $('.order-lookup').append(orderDetails);
      }
    },
    error: function (xhr, status, error) {
      var orderDetails = `<div class="details-container" style="font-size: 20px;">Unfortunately, we couldn't retrieve the requested data. For further support, please retry your request or contact sales@tronair.com.</div>`;
      $('.order-lookup').append(orderDetails);
      console.log(error);
    }
  });
}

function findShipment (response, lineItem) {
  for (let i = 0; i < response.shippedItems.length; i++){
    const shipment = response.shippedItems[i];
    if (shipment.item == lineItem.internalItem) {
      return shipment;
    }
  }
  return null;
}

function getOrders(start = null, end = null, partNumber = null) {
  $('.details-container').remove();

  var customerId = $('#customer-id').val();

  var data = { customerId: customerId };
  if (start) data.startDate = start;
  if (end) data.endDate = end;
  if (partNumber) data.partNumber = partNumber;

  console.log(baseUrl + '/shopify/getorders')
  console.log(data)

  $.ajax({
    url: baseUrl + '/shopify/getorders',
    type: 'GET',
    data,
    success: function (response) {
      if(!!response) {
        if (response.length) {
          console.log(response)
          var orderDetails = `<div class="details-container">`;
          orderDetails += `<table role="table" class="order-details">`;
          orderDetails += `<thead role="rowgroup" style="background-color: #326cb0; color: white;">`;
          orderDetails += `<th id="ColumnOrderNumber" scope="col" role="columnheader">Order Number</th>`;
          orderDetails += `<th id="ColumnPurchaseOrderNumber" scope="col" role="columnheader">PO Number</th>`;
          // orderDetails += `<th id="ColumnOrderTotal" scope="col" role="columnheader">Order Total</th>`;
          orderDetails += `<th id="ColumnOrderDate" scope="col" role="columnheader">Order Date</th>`;
          orderDetails += `</tr></thead>`;
          orderDetails += `<tbody role="rowgroup">`;

          response.forEach(order => {
            const orderNumber = order.order.trim();
            const orderPurchaseOrderNumber = order.purchaseOrderNumber.trim();
            const orderTotal = parseFloat(order.invoiceTotal).toFixed(2);
            const orderDate = new Date(order.orderDate).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            });

            orderDetails += `<tr role="row">`;
            orderDetails += `<td headers="ColumnOrderNumber" role="rowheader" scope="row" data-label="Order Number"><a href="javascript:searchOrder(${orderNumber});" class="order-link">${orderNumber}</a></td>`;
            orderDetails += `<td headers="ColumnPurchaseOrderNumber" role="cell" data-label="Purchase Order Number">${orderPurchaseOrderNumber}</td>`;
            // orderDetails += `<td headers="ColumnOrderTotal" role="cell" data-label="Order Total">${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(orderTotal)}</td>`;
            orderDetails += `<td headers="ColumnOrderDate" role="cell" data-label="Order Date">${orderDate}</td>`;
            orderDetails += `</tr>`;
          });

          orderDetails += `</tbody>`;
          orderDetails += `</table>`;
          orderDetails += `</div>`;

          $('.order-lookup').append(orderDetails);
        } else {
          var orderDetails = `<div class="details-container" style="font-size: 20px;">Unfortunately, we couldn't retrieve the requested data. For further support, please retry your request or contact sales@tronair.com.</div>`;
          $('.order-lookup').append(orderDetails);
        }
      }
    },
    complete: function () {
      $('#order-lookup-input').val('');
    },
    error: function (xhr, status, error) {
      var orderDetails = `<div class="details-container" style="font-size: 20px;">Unfortunately, we couldn't retrieve the requested data. For further support, please retry your request or contact sales@tronair.com.</div>`;
      $('.order-lookup').append(orderDetails);
      console.log(error);
    }
  });
}